import { useState } from "react";
import { styled } from "styled-components";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

const Step2 = ({ websiteUrl, onWebsiteUrlChange }) => {
  const [showWebsiteUrl, setShowWebsiteUrl] = useState(websiteUrl);

  return (
    <FormControl>
      <RadioGroup defaultValue="no" name="existingSoftware">
        <FormControlLabel
          value="no"
          checked={!websiteUrl && !showWebsiteUrl}
          control={<Radio />}
          label="I don't have an existing website or application."
          onClick={() => {
            onWebsiteUrlChange("");
            setShowWebsiteUrl(false);
          }}
        />

        <FormControlLabel
          value="yes"
          control={<Radio />}
          label="I have an existing website or application."
          checked={!!websiteUrl || showWebsiteUrl}
          onClick={() => setShowWebsiteUrl(true)}
        />
      </RadioGroup>

      {(showWebsiteUrl || websiteUrl) && (
        <WebsiteInput
          placeholder="Your website URL or application name..."
          type="text"
          required
          value={websiteUrl}
          onChange={(e) => onWebsiteUrlChange(e.target.value.trim())}
        />
      )}
    </FormControl>
  );
};

const WebsiteInput = styled.input`
  border: 2px solid lightgray;
  border-radius: 8px;
  padding: 0.25rem 0.5rem;
  outline-color: #ff6341;

  ::placeholder {
    font-size: 10px !important;
  }
`;

export default Step2;
